import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

import { EmptyState } from "app/pages/activation/components/HomeWithData/Alerts/EmptyState/EmptyState";
import { Items } from "app/pages/activation/components/HomeWithData/Alerts/Items";
import { ALERTS_TITLE, VIEW_ALL_ALERTS } from "app/pages/activation/components/HomeWithData/Alerts/texts";
import { alertsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { SectionTitle } from "app/pages/activation/components/HomeWithData/SectionTitle";
import { PingIndicator } from "app/pages/activation/components/Shared/PingIndicator/PingIndicator";

import * as SC from "./styles";
import { useAlerts } from "./useAlerts";

type AlertsSchema = {
    onClickCreateProject: () => void;
};

export const Alerts = ({ onClickCreateProject }: AlertsSchema) => {
    const { translate } = useTranslate();

    const {
        isLoading,
        hasNewAlerts,
        isAllRead,
        shouldShowViewBtn,
        totalNumber,
        alerts,
        onViewAlerts,
        goToAlerts,
        containerRef,
    } = useAlerts();

    return (
        <SC.Container
            ref={containerRef}
            data-automation={alertsDataAutomation.container}
        >
            <SC.Header data-automation={alertsDataAutomation.header}>
                <SectionTitle
                    title={translate(ALERTS_TITLE)}
                    dataAutomation={alertsDataAutomation.title}
                />

                {hasNewAlerts ? <PingIndicator /> : null}

                {shouldShowViewBtn ? (
                    <SC.ButtonContainer>
                        {totalNumber && !isLoading ? (
                            <Button
                                type="flat"
                                onClick={onViewAlerts}
                                dataAutomation={alertsDataAutomation.viewAllBtn}
                            >
                                {translate(VIEW_ALL_ALERTS)}
                            </Button>
                        ) : null}
                    </SC.ButtonContainer>
                ) : null}
            </SC.Header>

            {isAllRead ? (
                <EmptyState />
            ) : (
                <SC.ItemsContainer data-automation={alertsDataAutomation.itemsContainer}>
                    <Items
                        isLoading={isLoading}
                        hasAlerts={hasNewAlerts}
                        onClickCreateProject={onClickCreateProject}
                        onItemClick={goToAlerts}
                        alerts={alerts}
                    />
                </SC.ItemsContainer>
            )}
        </SC.Container>
    );
};
